export default class RenderMap {
  constructor(el, props, refs) {
    const token = props.token;

    if (!token) {
      // eslint-disable-next-line no-console
      console.warn(
        "Warning: A Mapbox token is required to render an interactive map"
      );
      return null;
    }

    // import mapbox-gl as a separate chunk to reduce overall js bundle size
    import(/* webpackChunkName: "mapboxgl" */ "mapbox-gl").then(
      ({ default: mapboxgl }) => {
        mapboxgl.accessToken = token;

        if (!mapboxgl.supported()) {
          return null;
        } else {
          this.currentLocation = {
            name: "Michael Rosenfeld Gallery",
            lat: 40.7460919,
            long: -74.0075027,
          };

          this.map = new mapboxgl.Map({
            container: el,
            style:
              "mapbox://styles/michaelrosenfeldgallery/ck9j42il404ib1io9seftwqsa",
            center: [this.currentLocation.long, this.currentLocation.lat],
            zoom: 15,
          });

          this.map.on("load", () => {
            this.renderMarker(mapboxgl);
          });
        }
      }
    );
  }

  renderMarker(mapboxgl) {
    const geojson = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [this.currentLocation.long, this.currentLocation.lat],
          },
          properties: {
            title: "Mapbox",
            description: this.currentLocation.name,
          },
        },
      ],
    };

    // add markers to map
    geojson.features.forEach((marker) => {
      // create an HTML element for each feature
      const el = document.createElement("div");
      el.className = "m-map__marker";

      // make a marker for each feature and add to the map
      new mapboxgl.Marker(el)
        .setLngLat(marker.geometry.coordinates)
        .addTo(this.map);
    });
  }
}
